import React from "react";
import { HelpIndicator } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import * as styles from "./styles_vanilla.css";

export type StatusHelpProps = {
  isBaseline: boolean;
  isReady: boolean;
  isFork: boolean;
};

type HelpScenario = "baseline" | "devbox" | "fork";

const HELP_COPY: Record<HelpScenario, string> = {
  baseline: "Baseline is the default shared environment with no sandbox changes applied",
  devbox: "A dev sandbox previews changes from your local environment and is not shareable",
  fork: "A fork sandbox previews changes from its associated pull request and can be shared",
};

const getHelpScenario = ({ isBaseline, isFork }: StatusHelpProps): HelpScenario => {
  if (isBaseline) return "baseline";
  return isFork ? "fork" : "devbox";
};

export const getStatusHelpContent = (props: StatusHelpProps): string =>
  HELP_COPY[getHelpScenario(props)];

export const StatusHelp: React.FC<StatusHelpProps> = ({ isBaseline, isReady, isFork }) => (
  <HelpIndicator
    content={getStatusHelpContent({ isBaseline, isReady, isFork })}
    id="remocal-help-indicator"
  >
    <button type="button" className={styles.triggerStyle} aria-label="Help">
      <Icon type="question-circle" variant="outline" size="small" aria-hidden="true" />
    </button>
  </HelpIndicator>
);
